import{a as e,d as l}from"./chunk-XGSS6N64.js";import{m as a}from"./chunk-HBP5N4FR.js";a();l();var s=()=>{var o,r;return Boolean(((o=e)==null?void 0:o.isOpera)&&((r=e)==null?void 0:r.elrond))};export{s as a};
//# sourceMappingURL=chunk-H76UKCWZ.js.map
